import React from "react";
import 'bootstrap/dist/css/bootstrap.css';
import './AdminHome.css';
import fontawesome from '@fortawesome/fontawesome'
import {faCheckSquare, faCoffee} from '@fortawesome/fontawesome-free-solid'
import {AppConfig} from "../AppConfig";
import Cookies from 'universal-cookie';
import Nav from '../components/panel/Nav'
import User from "../components/admin/User";
import UserForm from "../components/admin/UserForm";
import UserDepartment from "../components/admin/UserDepartment";
import UserFormEdit from "../components/admin/UserFormEdit";
import UserCall from "../components/admin/UserCall";
import Call from "../components/admin/Call";
import AssignCall from "../components/admin/AssignCall";
import Reports from "../components/admin/Reports";
import ReportDetail from "../components/admin/ReportDetail";
import {globalSession} from "../module/Session";

fontawesome.library.add(faCheckSquare, faCoffee);


const cookies = new Cookies();

class AdminHome extends React.Component {

    page = null;


    getLink(l) {
        return "/" + l.replace(AppConfig.baseUrl, "")
    }

    constructor(props) {
        super(props);
        this.props = props;

        if (!globalSession.check())
            window.location = AppConfig.pages.login;

        const pathname = window.location.pathname.toString();

        if (pathname === this.getLink(AppConfig.pages.admin.operators)) {
            this.page = <User/>;
        } else if (pathname === this.getLink(AppConfig.pages.admin.newOperator)) {
            this.page = <UserForm/>;
        } else if (pathname === this.getLink(AppConfig.pages.admin.department)) {
            this.page = <UserDepartment/>
        } else if (pathname === this.getLink(AppConfig.pages.admin.editOperator)) {
            this.page = <UserFormEdit/>
        } else if (pathname === this.getLink(AppConfig.pages.admin.calls)) {
            this.page = <Call/>
        } else if (pathname === this.getLink(AppConfig.pages.admin.assignCall)) {
            this.page = <AssignCall/>
        } else if (pathname === this.getLink(AppConfig.pages.admin.call)) {
            this.page = <UserCall/>
        } else if (pathname === this.getLink(AppConfig.pages.admin.reports)) {
            this.page = <Reports/>
        } else if (pathname === this.getLink(AppConfig.pages.report.reportBase)) {
            this.page = <ReportDetail/>;
        } else {
            this.page = <div>
                {/*<div className="alert alert-primary" role="alert">*/}
                {/*    This is a primary alert—check it out!*/}
                {/*</div>*/}
                {/*<div className="alert alert-secondary" role="alert">*/}
                {/*    This is a secondary alert—check it out!*/}
                {/*</div>*/}
                <div className="alert alert-success" role="alert">
                    Çağrı Takip Sistemi Admin Paneline Hoşgeldiniz
                </div>
                {/*<div className="alert alert-danger" role="alert">*/}
                {/*    This is a danger alert—check it out!*/}
                {/*</div>*/}
                {/*<div className="alert alert-warning" role="alert">*/}
                {/*    This is a warning alert—check it out!*/}
                {/*</div>*/}
                {/*<div className="alert alert-info" role="alert">*/}
                {/*    This is a info alert—check it out!*/}
                {/*</div>*/}
                {/*<div className="alert alert-light" role="alert">*/}
                {/*    This is a light alert—check it out!*/}
                {/*</div>*/}
                {/*<div className="alert alert-dark" role="alert">*/}
                {/*    This is a dark alert—check it out!*/}
                {/*</div>*/}
            </div>
        }
    }

    render() {
        return (
            <div>
                <Nav/>
                <div id="pageContent">
                    {this.props.children}
                    {this.page}
                </div>
            </div>
        )
    }

}

export default AdminHome;